import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// @ts-ignore
import Point from "../../geo/point";
import DOM from "../../utils/dom";
import { Event } from "./event";

var MapTouchEvent = /*#__PURE__*/function (_Event) {
  _inherits(MapTouchEvent, _Event);

  var _super = _createSuper(MapTouchEvent);

  /**
   * The event type.
   */

  /**
   * The `Map` object that fired the event.
   */

  /**
   * The DOM event which caused the map event.
   */

  /**
   * The geographic location on the map of the center of the touch event points.
   */

  /**
   * The pixel coordinates of the center of the touch event points, relative to the map and measured from the top left
   * corner.
   */

  /**
   * The array of pixel coordinates corresponding to a
   * [touch event's `touches`](https://developer.mozilla.org/en-US/docs/Web/API/TouchEvent/touches) property.
   */

  /**
   * The geographical locations on the map corresponding to a
   * [touch event's `touches`](https://developer.mozilla.org/en-US/docs/Web/API/TouchEvent/touches) property.
   */

  /**
   * `true` if `preventDefault` has been called.
   * @private
   */

  /**
   * @private
   */
  function MapTouchEvent(type, map, originalEvent) {
    var _this;

    _classCallCheck(this, MapTouchEvent);

    var touches = type === 'touchend' ? originalEvent.changedTouches : originalEvent.touches;
    var points = DOM.touchPos(map.getCanvasContainer(), touches);
    var lngLats = points.map(function (t) {
      return map.unproject(t);
    });
    var point = points.reduce(function (prev, curr, i, arr) {
      return prev.add(curr.div(arr.length));
    }, new Point(0, 0));
    var lngLat = map.unproject(point);
    _this = _super.call(this, type, {
      points: points,
      point: point,
      lngLats: lngLats,
      lngLat: lngLat,
      originalEvent: originalEvent
    });
    _this.defaultPrevented = false;
    return _this;
  }
  /**
   * Prevents subsequent default processing of the event by the map.
   *
   * Calling this method will prevent the following default map behaviors:
   *
   *   * On `touchstart` events, the behavior of {@link DragPanHandler}
   *   * On `touchstart` events, the behavior of {@link TouchZoomRotateHandler}
   *
   */


  _createClass(MapTouchEvent, [{
    key: "preventDefault",
    value: function preventDefault() {
      this.defaultPrevented = true;
    }
  }]);

  return MapTouchEvent;
}(Event);

export { MapTouchEvent as default };